import React from 'react';

const DateTimeDisplay = ({ value, isDanger }) => {
    return (
        <div className={isDanger ? 'text-danger' : 'text-success'}>
            <p className='ms-1 me-1 mt-1'>
                <strong>{value}</strong>
            </p>
        </div>
    );
};

export default DateTimeDisplay;